 
<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <h4 class="personal-details-title">Modify Roles List</h4>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">Role Name</th>
                            <th scope="col">Created Date</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let role of roles | paginate : {
                            itemsPerPage: tableSize,
                            currentPage: page,
                            totalItems: count
                            };let i=index">
                            <th scope="col" >{{role.roleName}}</th>
                            <th scope="col" >{{role.createdDate | date}}</th>
                            <th>
                                <i (click)="getRoleById(role.roleId)" data-toggle="modal" data-target="#updateModal" class="bi bi-eye-fill"></i>
                            </th>
                        </tr>
                    </tbody>
                </table>
                <div class="pagination-block" *ngIf="roles.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                </div>
            </div>
        </div>
    </div>
</div>
  
  
<div class="modal fade" id="updateModal" tabindex="-1"   aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">UPDATE ROLE
                <span data-dismiss="modal">
                    <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                </span>
            </h5>
            </div>
            <div class="modal-body">
            <div [formGroup]="editForm">
                <div class="form-group">
                <div class="row">
                    <div class="col-md-12 col-lg-12">
                        <label>Role Name <span class="required-field">*</span></label>
                        <input formControlName="roleName" type="text" class="form-control">
                    </div>
                    <div class="col-md-12 col-lg-12">
                        <div class="singleData" *ngFor="let role of privileges;let i = index">
                            <div class="single-role-header">
                                <input (click)="isChecked($event,i)" [checked]="role.isChecked" type="checkbox">
                                <label>{{role.groupName}}</label>
                            </div>
                            <div class="single-role-table">
                                <table class="table table-striped">
                                    <thead>
                                          <tr>
                                            <th style="width: 5%;"></th>
                                            <th style="width: 5%;">S.No.</th>
                                            <th style="width: 35%;">Name</th>
                                            <th style="width: 55%;">Description</th>
                                          </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let screenPrivilegeList of role.screenPrivilegeList;let j = index">
                                            <th><input type="checkbox" (click)="screenCheck($event,i,j)" [checked]="screenPrivilegeList.isChecked"></th>
                                            <th>{{screenPrivilegeList.seqNo}}</th>
                                            <th>{{screenPrivilegeList.name}}</th>
                                            <th>{{screenPrivilegeList.description}}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="updateRole()" *ngIf="editButton" class="btn btn-primary">save changes</button>
                </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>